/* Bline v2: set in de winkelwagen (losse producten), zelfde lade als de upsell. */
(function () {
  function voegToe(e) {
    var knop = e.target.closest && e.target.closest('[data-bline-items]');
    if (!knop) return;
    e.preventDefault();
    var items;
    try { items = JSON.parse(knop.getAttribute('data-bline-items')); } catch (err) { return; }
    knop.setAttribute('aria-busy', 'true');
    var lade = document.querySelector('cart-drawer');
    var secties = lade && typeof lade.getSectionsToRender === 'function'
      ? lade.getSectionsToRender().map(function (s) { return s.id; }) : ['cart-drawer', 'cart-icon-bubble'];
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: secties, sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state && state.sections && lade && typeof lade.renderContents === 'function') { lade.renderContents(state); }
        else { window.location.href = '/cart'; }
      })
      .catch(function () { window.location.href = '/cart'; })
      .finally(function () { knop.removeAttribute('aria-busy'); });
  }
  document.addEventListener('click', voegToe);
})();
